import cn from 'classnames';
import { PropsWithChildren, useRef, useState } from 'react';

import s from './HoverPanel.module.scss';

type HoverPanelProps = PropsWithChildren & {
  isDragging?: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
};

export function HoverPanel({
  children,
  isDragging = false,
  onMouseEnter,
  onMouseLeave,
}: HoverPanelProps) {
  const [open, setOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const handleMouseEnter = () => {
    setOpen(true);
    onMouseEnter?.();
  };

  const handleMouseLeave = (e: React.MouseEvent) => {
    const container = containerRef.current;
    const target = e.relatedTarget;

    if (container && target instanceof Node && !container.contains(target)) {
      setOpen(false);
      onMouseLeave?.();
    }
  };

  return (
    <div
      ref={containerRef}
      className={s.container}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div
        className={cn(s.sidePanel, { [s.open]: open, [s.dragging]: isDragging })}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <button
          type="button"
          className={s.tab}
          aria-label="Открыть избранные задачи"
          onClick={handleMouseEnter}
        >
          <span className={s.tab__label}>Избранное</span>
        </button>

        <div className={s.sidePanel__content}>{children}</div>
      </div>
    </div>
  );
}
